import React from 'react'
import { modals } from '@mantine/modals'
import { Image, Box, Text } from '@mantine/core'
import { notificationSuccess, notificationError } from '../Notifications'
import SearchMascot from '../../../assets/img/mascot/18.png'

export const modalDeletePermanentUser = ( title, payload, name, functionDelete, reloadData ) => {

  const handleDeleteData = async (payload) => {
    try {
      const response = await functionDelete(payload)
      if (response.success) {
        notificationSuccess(`Delete Permanent ${title} successfully`,  `Data ${title} successfully deleted`)
        reloadData()
        modals.closeAll()
      }
    } catch (error) {
      console.log(error)
      notificationError(`Delete Permanent ${title} error`, `Cannot Delete data ${title}`)
    }
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    withCloseButton: false,
    size: 'lg',
    children: (
      <Box>
        <Box ta='center'>
          <Image src={SearchMascot} fit='contain' h='180' my={20} />
          <Text fw={500} mb={4}>Are you sure to permanent delete this {title} ? </Text>
          <Text fw='bold' mb={14}>"{name}"</Text>
          <Text fz='sm' c='gray.6' mb={20}>
            Permanent deleted user will deleted in our database. after delete this data cannot be returned or recovery
          </Text>
        </Box>
      </Box>
    ),
    labels: { confirm: 'Delete Now', cancel: "Cancel" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleDeleteData(payload),
  })
}
